<template>
  <div>
    <van-cell
      v-if="isNormalStyle"
      class="ry-form__dropdown">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
        <span
          v-if="current.showColor"
          :class="{'readonly-span' : currentRow[current.dataId] && currentRow[current.dataId].length}"
          :style="{backgroundColor : currentRow[current.dataId] && currentRow[current.dataId].length ? contentColor : ''}">
          {{contentText}}
        </span>
          <span v-else>
          {{contentText}}
        </span>
        </div>
        <div v-else-if="!isRead" @click="openSelect">
          <div class="ry-form__dropdown-input">
            <div class="select-item" :key="itemKey">
            <span
              :style="{backgroundColor: current.showColor ? actionsMap[currentValue].color || '#63B2EE' : '#fff', color: current.showColor ? '#fff' : '#000'}"
              v-if="currentValue">
              {{currentValue}}
            </span>
              <span v-else>
              {{current.fieldDes}}
            </span>
            </div>
            <van-icon
              v-if="currentValue && !isReadOnly"
              name="close"
              class="close-btn"
              @click.stop="clearData">
            </van-icon>
          </div>

        </div>

        <van-field
          v-if="!isRead && selectOption === '其他'"
          style="border: 1px solid #e6e6e6; padding: 5px;"
          v-model="currentRow[current.dataId]"
          @change="selectChange"
        ></van-field>

      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__dropdown-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>

          <div class="ry-form__select-compact-container" style="flex-direction: column;">

            <div
              v-if="isRead">
          <span
            v-if="current.showColor"
            class="field-empty-tips"
            :class="{'readonly-span' : currentRow[current.dataId] && currentRow[current.dataId].length}"
            :style="{backgroundColor : currentRow[current.dataId] && currentRow[current.dataId].length ? contentColor : ''}">
             {{contentText}}
          </span>
              <span v-else class="field-empty-tips">
            {{contentText}}
          </span>
            </div>

            <div v-else class="ry-form__dropdown-input compact-container" @click="openSelect">
              <div class="select-item">
            <span
              class="content"
              :style="itemStyle"
              v-if="currentValue">
              {{currentValue}}
            </span>
                <div v-else class="placeholder">
                  {{current.fieldDes || isReadOnly ? '暂无内容' : '请选择'}}
                </div>
              </div>
              <van-icon
                v-if="currentValue && !isReadOnly"
                name="close"
                class="close-btn"
                @click.stop="clearData">
              </van-icon>
            </div>

            <van-field
              v-if="!isRead && selectOption === '其他'"
              style="border: 1px solid #e6e6e6; padding: 5px;"
              v-model="currentRow[current.dataId]"
              @change="selectChange"
            ></van-field>
          </div>
        </template>
      </van-field>
    </div>

    <template v-if="['otherForm', 'current_table'].includes(current.optionsType)">
      <SelectOptionsPopup
        ref="selectOptionsPopup"
        :fetchType="current.optionsType"
        :app-id="formSet.appId"
        :form-id="formSet.formId"
        :field-id="current.dataId"
        :query-field-id="current.relateFieldId"
        :filter-info="current.filterInfo"
        :table-field-id="current.tableFieldId"
        :advanced-filter="current.advancedFilter"
        :advanced-filter-info="current.advancedFilterInfo"
        :relate-data-source-type="current.relateDataSourceType"
        :relateFieldId="current.relateFieldId"
        :relateAppId="current.relateAppId"
        :relateFormId="current.relateFormId"
        :data="formSet.getValues()"
        :row-idx="index + 1"
        :sortList="current.sortList"
        :currentTableId="current.currentTableId"
        :dataFieldId="current.dataFieldId"
        @selectComplete="selectValueComplete"
      ></SelectOptionsPopup>
    </template>
    <template v-if="current.optionsType === 'openApi'">
      <SelectOptionsPopup
        ref="selectOptionsPopup"
        fetchType="openApi"
        :app-id="formSet.appId"
        :form-id="formSet.formId"
        :field-id="current.dataId"
        :data="formSet.getValues()"
        :row-idx="index + 1"
        :requestType="current.requestType"
        :requestUrl="current.requestUrl"
        :methodType="current.methodType"
        :headerList="current.headerList"
        :paramType="current.paramType"
        :paramList="current.paramList"
        :requestBody="current.requestBody"
        :resultList="current.resultList"
        :updateList="current.updateList"
        :sortList="current.sortList"
        @selectComplete="selectValueComplete"
      ></SelectOptionsPopup>
    </template>
    <template v-if="current.optionsType === 'relateData'">
    </template>

    <div @click.stop.prevent>
      <van-action-sheet
        class="ry-form-action-sheet"
        v-model="show"
        :title="current.title"
        get-container="body"
        @select="onSelect"
        :close-on-click-action="true"
        :actions="actions">
      </van-action-sheet>

      <RySelectPopup
        v-if="current.pluginConfig && current.pluginConfig.entryId"
        ref="rySelectPopup"
        :title="current.title"
        @selectComplete="selectComplete">
      </RySelectPopup>
    </div>
  </div>

</template>

<script>
  import {current} from './mixin'
  import SelectOptionsPopup from "../component/SelectOptionsPopup";

  export default {
    mixins: [current],
    data() {
      return {
        itemKey: Math.random(),
        show: false,
        selectOption: ''
      }
    },
    components: {
      SelectOptionsPopup
    },
    computed: {
      // 获取options, 因为子表单选项类控件可能每一行不一样
      currentRowOpts() {
        const optionsMap = this.currentRow['optionsMap'] || {}
        return optionsMap[this.current.dataId] || this.current.options
      },
      currentValue() {
        if (this.current.optionsType === 'custom') {
          if (this.currentRow[this.current.dataId]) {
            const option = this.currentRowOpts.filter(opt => opt.id === this.currentRow[this.current.dataId])[0]
            if (!option || this.currentRow[this.current.dataId] === '其他') {
              this.selectOption = '其他'
            }
            return option ? option.optionName : '其他'
          } else {
            if (this.selectOption === '其他') {
              return '其他'
            }
            return ''
          }
        } else {
          return this.currentRow[this.current.dataId]
        }
      },
      contentText() {
        if (this.currentRow[this.current.dataId] && this.currentRow[this.current.dataId].length) {
          const opt = this.currentRowOpts
            .filter(opt => opt.id === this.currentRow[this.current.dataId])[0]
          return opt ? opt.optionName : this.currentRow[this.current.dataId]
        } else {
          return '暂无内容'
        }
      },
      contentColor() {
        if (this.currentRow[this.current.dataId] && this.currentRow[this.current.dataId].length) {
          const opt = this.currentRowOpts
            .filter(opt => opt.id ===this.currentRow[this.current.dataId])[0]
          return opt ? opt.color : '#63B2EE'
        } else {
          return ''
        }
      },
      actions() {
        const val = this.currentRow[this.current.dataId]
        if (this.currentRowOpts.length) {
          return this.currentRowOpts.map(item => {
            const result = { name: item.id }
            if (val === item.id) {
              result.color = item.color
            } else {
              result.color = 'transparent'
            }
            return result
          })
        } else {
          return [{ name: '暂无数据', disabled: true }]
        }

        // return this.currentRowOpts.map(item => {
        //   item.name = item.optionName
        //   if (!this.current.showColor) {
        //     item.color = "transparent"
        //   }
        //   return item
        // })
      },
      actionsMap() {
        const map = {}
        this.currentRowOpts.map(item => {
          map[item.id] = item
        })
        return map
      },
      itemStyle() {
        if (this.current.showColor) {
          return {
            backgroundColor: this.actionsMap[this.currentRow[this.dataId]] ? this.actionsMap[this.currentRow[this.dataId]].color || '#63B2EE' : '#63B2EE',
            color: '#fff',
            padding: '0 12px',
            margin: '2px',
          }
        } else {
          return {
            backgroundColor: '#fff',
            color: '#000',
            padding: 0,
            margin: 0,
          }
        }
      }
    },
    methods: {
      onSelect(opt) {
        this.selectOption = opt.name
        this.currentRow[this.dataId] = opt.name
        this.controlChange()
        this.selectChange()
      },
      clearData() {
        this.onSelect({id: ''})
        this.itemKey = Math.random()
      },
      openSelect() {
        if (this.isReadOnly) return
        if (['otherForm', 'current_table'].includes(this.current.optionsType)) {
          if (this.$refs.selectOptionsPopup) {
            this.$refs.selectOptionsPopup.open(this.currentRow[this.dataId])
          }
        } else if (this.current.optionsType === 'openApi') {
          if (this.$refs.selectOptionsPopup) {
            this.$refs.selectOptionsPopup.open(this.currentRow[this.dataId])
          }
        } else if (this.current.optionsType === 'relateData') {
          if (this.$refs.selectOptionsPopup) {
            this.$refs.selectOptionsPopup.open(this.currentRow[this.dataId])
          }
        } else {
          this.show = true
        }
      },
      selectChange() {
        this.controlChange()
        this.submitData()
      },
      selectValueComplete(val) {
        this.selectOption = val
        this.currentRow[this.dataId] = val
        this.selectChange()
      },
    }
  }
</script>
